<script lang="ts">
	import { SvgWrapper } from '../../../storybook-util/icons/components/SvgWrapper';
	import { getTailwindColor } from '../../../storybook-util/icons/utils/getTailwindColor/getTailwindColor';
	interface Props {
		color?: string | undefined;
		title?: string | undefined;
		class?: string;
	}

	let { color = 'gray-900', title = undefined, ...rest }: Props = $props();
</script>

<SvgWrapper {title} {...rest} width="161" height="16" viewBox="0 0 161 16">
	<path
		d="M33.6096 3.01703V0.000209477H23.9905V16H33.7224V12.9828H27.0918V9.3941H33.0481V6.4228H27.0918V3.01703H33.6096Z"
		fill={getTailwindColor(color)}
	/>
	<path
		d="M3.10168 6.35432V0H0V15.9998H3.10168V9.37156H8.94536V15.9998H12.0247V0H8.94536V6.35432H3.10168Z"
		fill={getTailwindColor(color)}
	/>
	<path
		d="M53.9694 9.76009L47.2265 0H44.8666V15.9998H47.9682V6.21736L54.7111 15.9998H57.0711V0H53.9694V9.76009Z"
		fill={getTailwindColor(color)}
	/>
	<path d="M72 15.9998V0H68.8987V15.9998H72Z" fill={getTailwindColor(color)} />
	<path
		d="M90.7155 1.91704V15.7109H92.5003V1.91704H97.2158V0.286455H86V1.91704H90.7155Z"
		fill={getTailwindColor(color)}
	/>
	<path
		d="M101.335 15.7109L102.723 12.0531H110.171L111.559 15.7109H113.432L107.505 0.286455H105.412L99.4622 15.7109H101.335ZM106.381 2.35774H106.513L109.554 10.4225H103.34L106.381 2.35774Z"
		fill={getTailwindColor(color)}
	/>
	<path
		d="M127.887 15.7109V14.1024H121.233V0.286455H119.448V15.7109H127.887Z"
		fill={getTailwindColor(color)}
	/>
	<path
		d="M136.357 15.7109V10.687L138.472 8.21905L143.342 15.7109H145.546L139.684 6.80881L145.281 0.286455H143.056L136.489 8.0648H136.357V0.286455H134.572V15.7109H136.357Z"
		fill={getTailwindColor(color)}
	/>
	<path
		d="M149.453 11.1277C149.409 13.9261 151.943 16.0855 154.962 15.9974C156.592 15.9974 157.892 15.5787 158.862 14.7634C159.831 13.9261 160.316 12.8905 160.316 11.6345C160.316 5.39857 151.767 8.32922 151.767 4.12054C151.767 2.73234 152.846 1.63059 154.896 1.63059C156.989 1.63059 158.157 2.7103 158.157 4.4731H159.986C159.986 1.30006 157.231 0 154.918 0C153.419 0 152.229 0.39663 151.326 1.21192C150.422 2.00518 149.982 2.97472 149.982 4.12054C149.982 10.2903 158.509 6.89695 158.509 11.7446C158.509 13.3312 157.077 14.3448 155.028 14.3448C153.882 14.3448 152.956 14.0363 152.273 13.4193C151.59 12.8023 151.238 12.0311 151.238 11.1277H149.453Z"
		fill={getTailwindColor(color)}
	/>
</SvgWrapper>
